import * as React from "react"
const SvgDownloadFile = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 15.171v-3.175a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288.97.97 0 0 1 .713.288q.287.288.287.712v3.175l.9-.9a1 1 0 0 1 .338-.225q.188-.075.375-.062a1.04 1.04 0 0 1 .688.313q.273.3.287.7a.92.92 0 0 1-.288.7l-2.6 2.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.062q-.2 0-.375-.062a.9.9 0 0 1-.325-.213l-2.6-2.6a.92.92 0 0 1-.288-.7q.013-.4.313-.7.3-.275.7-.287.4-.013.7.287z" />
    <path
      fillRule="evenodd"
      d="M4.588 21.984q.587.587 1.412.587h12q.824 0 1.413-.587A1.93 1.93 0 0 0 20 20.571V9.396a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.588A1.93 1.93 0 0 0 4 4.57v16q0 .825.588 1.413ZM13 4.57v4a.97.97 0 0 0 .287.713q.288.287.713.287h4v11H6v-16z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgDownloadFile
